import { put, takeLeading } from 'redux-saga/effects';

import marketApi from 'api/marketApi';
import { apiErrorHandler } from 'utils';

import { GET_MARKET_LIST } from './actionTypes';

import {
  actionGetMarketListSuccess,
  actionGetMarketListFailed,
} from './actions';

function* getMarketList({ payload }) {
  const { append, ...apiPayload } = payload || {};

  try {
    const response = yield marketApi.getMarkets(apiPayload);

    yield put(
      actionGetMarketListSuccess({
        ...response.payload,
        append: !!append,
      }),
    );
  } catch (error) {
    apiErrorHandler(error);

    yield put(actionGetMarketListFailed());
  }
}

export default function* marketSaga() {
  yield takeLeading(GET_MARKET_LIST, getMarketList);
}
